const CachedItem = {
  token: "token",
  account: "account",
};

export const SessionCacheItem = {
  product: "product",
  adminPath: "adminPath",
};

export const CacheItem = (key: string, data: any, isString?: boolean) => {
  let dataToBeCached = data;
  if (!isString) {
    dataToBeCached = JSON.stringify(dataToBeCached);
  }
  localStorage.setItem(key, dataToBeCached);
};

export const LoadCachedItem = (key: string, isString?: boolean): any => {
  const data = localStorage.getItem(key);
  if (!data) return "";

  // Only attempt to parse if it looks like JSON and isString is not true
  if (!isString && (data.startsWith("{") || data.startsWith("["))) {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error("Error parsing JSON from local storage:", error);
      return null;
    }
  }

  // Return the data as a string if it doesn't look like JSON
  return data;
};

export const CacheItemSession = (
  key: string,
  data: any,
  isString?: boolean
) => {
  let dataToBeCached = data;
  if (!isString) {
    dataToBeCached = JSON.stringify(dataToBeCached);
  }
  sessionStorage.setItem(key, dataToBeCached);
};

export const LoadCachedItemSession = (key: string, isString?: boolean): any => {
  const data = sessionStorage.getItem(key);
  if (!data) return "";

  // Only attempt to parse if it looks like JSON and isString is not true
  if (!isString && (data.startsWith("{") || data.startsWith("["))) {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error("Error parsing JSON from session storage:", error);
      return null;
    }
  }

  // Return the data as a string if it doesn't look like JSON
  return data;
};

export default CachedItem;
